export default __webpack_public_path__ + "static/media/Deeper learning.6743d98a.png";